import { callApi } from "../utils/apiUtils";

import { folderEndpoints } from "./endpoints/folder";

export const addFolder = ({ body }) =>
  callApi({ uriEndPoint: folderEndpoints.addFolder.v1, body });
export const getFolder = ({ query }) =>
  callApi({ uriEndPoint: folderEndpoints.getFolder.v1, query });
export const getSubFolder = ({ pathParams }) =>
  callApi({ uriEndPoint: folderEndpoints.getSubFolder.v1, pathParams });
export const addSubFolder = ({ pathParams, body }) =>
  callApi({ uriEndPoint: folderEndpoints.addSubFolder.v1, pathParams, body });

export const updateFolder = ({ body, pathParams }) =>
  callApi({ uriEndPoint: folderEndpoints.updateFolder.v1, body, pathParams });
export const updateSubFolder = ({ body, pathParams }) =>
  callApi({
    uriEndPoint: folderEndpoints.updateSubFolder.v1,
    body,
    pathParams,
  });
export const deleteFolder = ({ pathParams }) =>
  callApi({ uriEndPoint: folderEndpoints.deleteFolder.v1, pathParams });
export const addFolderImages = ({ pathParams, body }) =>
  callApi({
    uriEndPoint: folderEndpoints.addFolderImages.v1,
    pathParams,
    body,
  });
export const getFolderImages = ({ pathParams, query }) =>
  callApi({
    uriEndPoint: folderEndpoints.getFolderImages.v1,
    pathParams,
    query,
  });
export const deleteFolderImages = ({ body }) =>
  callApi({ uriEndPoint: folderEndpoints.deleteFolderImages.v1, body });
